'use strict';

var _require = require('./Component');

var CopyToClipboard = _require.CopyToClipboard;


module.exports = CopyToClipboard;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-copy-to-clipboard/lib/index.js
// module id = 102
// module chunks = 0